import { useSelector } from 'react-redux';
import { citySelectionIsOpenSelector } from './slice';

export const useIsCitySelectionOpen = (): boolean => {
  return useSelector(citySelectionIsOpenSelector);
};
